<template>
    <div>
        <Head :title="$t('projects.projects')" />
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-8">
        <page-title
            :title="$t('projects.projects')"
            :pages="breadcrumbPages"
            class="mb-2 sm:mb-0"
        ></page-title>
        <div class="flex md:mt-0 md:ml-4">
            <div class="flex">
                <switch-input
                    :label="$t('projects.inactiveProjects')"
                    v-model="form.withArchive"
                ></switch-input>
                <switch-input
                    :label="$t('projects.myProjects')"
                    v-model="form.onlyMine"
                ></switch-input>
            </div>
            <primary-button @click="toCreatePage()">
                <PlusSmIcon
                    class="-ml-1 md:mr-2 h-5 w-5 text-white md:text-minplan-darkgreybeige"
                />
                <span class="hidden md:inline font-bold">{{
                    $t("projects.newProject")
                }}</span>
            </primary-button>
        </div>
        </div>
    </div>

    <div class="flex-1 flex justify-center">
        <div class="w-full">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-400 focus-within:text-gray-600">
                <div
                    class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
                >
                    <SearchIcon class="h-5 w-5" aria-hidden="true" />
                </div>
                <input
                    id="search"
                    class="block w-full py-2 pl-10 pr-3 border border-minplan-beige rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-minplan-beige focus:ring-white focus:border-white sm:text-sm"
                    placeholder="Suche..."
                    autocomplete="off"
                    type="search"
                    name="search"
                    v-model="form.search"
                />
            </div>
        </div>
    </div>

    <ul role="list" class="mt-6">
        <li v-for="project in projects.data" :key="project.uuid">
            <project-card :project="project"></project-card>
        </li>
    </ul>

    <!-- Pagination -->
    <pagination :links="projects.links"></pagination>
</template>

<script>
import { defineComponent, ref } from "vue";
import ProjectCard from "@/Pages/Projects/Components/ProjectCard";
import MainLayout from "@/Layouts/MainLayout";
import { mapValues, pickBy, throttle } from "lodash";
import { PlusSmIcon, SearchIcon } from "@heroicons/vue/outline";
import Pagination from "@/Shared/Components/Pagination";
import PageTitle from "@/Shared/Components/PageTitle";
import SwitchInput from "@/Shared/Components/SwitchInput";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import { Head } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: {
        filter: Object,
        projects: Object,
    },
    layout: MainLayout,
    components: {
        Head,
        ProjectCard,
        PlusSmIcon,
        SearchIcon,
        Pagination,
        PageTitle,
        SwitchInput,
        PrimaryButton,
    },
    setup() {
        const enabled = ref(false);
        const enabledActive = ref(false);

        return {
            enabled,
            enabledActive,
        };
    },
    data() {
        return {
            form: {
                search: this.filter.search,
                withArchive: this.filter.withArchive,
                onlyMine: this.filter.onlyMine,
            },
            breadcrumbPages: [
                {
                    name: this.$t("projects.projects"),
                    href: this.route("advisors.projects.index"),
                    current: true,
                },
            ],
        };
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "filter[search]": this.form.search,
                    "filter[withArchive]": this.form.withArchive,
                    "filter[onlyMine]": this.form.onlyMine,
                };

                this.$inertia.get(this.route("advisors.projects.index"), pickBy(query), {
                    preserveState: true,
                });
            }, 150),
        },
    },
    methods: {
        toCreatePage() {
            this.$inertia.get(this.route("advisors.projects.create"));
        },
        reset() {
            this.form = mapValues(this.form, () => null);
        },
    },
});
</script>

<style scoped></style>
